/**
 * Bitmart Futures Cloud
 */

import axiosOrigin, { HttpStatusCode } from 'axios'
// import { setupCache } from 'axios-cache-interceptor';
import { getCurHost } from '~/frontend-shared/helper/dom';

export interface ContractResponse<T = unknown> {
  data?: T;
  success?: boolean;
  message: string;
  errno: string;
  status?: number;
}

const instance = axiosOrigin.create({
  baseURL: '',
  headers: {
    'Cache-Control': 'no-cache',
  },
  timeout: 20 * 1000,
})

export function setAxiosConfig() {
  const $curHost = getCurHost(window?.location?.origin);
  instance.defaults.baseURL = $curHost?.contractApiHostV2;
}

// export const axiosClientBFC = setupCache(instance, axiosCacheConfig);
export const axiosClientBFC = instance;
// axiosClientBFC.defaults.cache.cacheTakeover = false;
// axiosClientBFC.defaults.cache.cachePredicate = {
//   statusCheck: status => HttpStatusCode.Ok === status,
//   responseMatch: res => {
//     const data = res.data as ContractResponse;
//     return !!data.success;
//   },
// };
// 全局 ttl 为 60s
// axiosClientBFC.defaults.cache.ttl = 45 * 1e3;

axiosClientBFC.interceptors.request.use(async config => {
  // 解决axios-retry重试时，参数重复的问题
  if (config.url) {
    config.url = config.url.split('?')[0];
  }
  config.startTime = Date.now()
  // config.headers.Host='contract-sandbox.bitmarttest.com'
  return config;
});

axiosClientBFC.interceptors.response.use(res => {
  if (+res.status === HttpStatusCode.NoContent) {
    return res
  }
  if (+res.status !== HttpStatusCode.Ok) {
    return res
  }
  // CLOUD_API_KEY_EXPIRED  INVALID_EXPIRED_TS 过期
  if (res.data.errno === 'OK') {
    return res.data
  }
  return res;
}, err => {
  if (err?.config?.span) {
    err.config.span.setAttribute('http.response.status_code', err.status);
    err.config.span.end();
  }
  return err;
})
